import flatpickr from 'flatpickr';
import {German} from 'flatpickr/dist/l10n/de.js';
import flatpickrCss from 'flatpickr/dist/flatpickr.min.css';

const domElements = {};
const availableDates = [];
let flatpickerInstance;
let activeDate = '';
let dynamicSuggestion;

function initDomElements() {
  domElements.main = $('.order__step--3');
  if (domElements.main.length < 1) return false;
  domElements.dateInput = domElements.main.find('#dateInput');
  domElements.dates = domElements.main.find('.order__step--3__date');
  domElements.suggestionsWrap = domElements.main.find('.times__suggestions');
  domElements.suggestions = domElements.main.find('.times__suggestion input');
  return true;
}

function step3() {
  if (!initDomElements()) {
    return false;
  }

  parseDates();
  initalizeDatePicker();
  initalizeSuggestions();
}

function initalizeDatePicker() {
  flatpickerInstance = domElements.dateInput.flatpickr({
    inline: true,
    minDate: 'today',
    dateFormat: 'd.m.Y',
    locale: German,
    enable: availableDates,
    onChange: () => {
      activeDate = domElements.dateInput.val();
      updateSuggestions();
    }
  });
}

function initalizeSuggestions() {
  domElements.suggestions.on('change', event => {
    let $checkbox = $(event.currentTarget);
    let date = $checkbox.val();
    activeDate = date;
    flatpickerInstance.setDate(activeDate);
//    domElements.dateInput.val(activeDate);
    updateSuggestions();
  });
}

function updateSuggestions() {
  let matchCheckbox = false;
  domElements.suggestions.each((index, element) => {
    let $checkbox = $(element);
    if ($checkbox.val() === activeDate) {
      $checkbox.prop('checked', true);
      matchCheckbox = true;
    } else {
      $checkbox.prop('checked', false);
    }
  });


  if (matchCheckbox === false) {
    addDynamicCheckbox(activeDate);
    updateSuggestions();
  }

  removeUnusedDynamicCheckbox();
}

function addDynamicCheckbox(date) {
  console.log('addDynamicCheckbox', date);
  let $newCheckbox = $(domElements.suggestions[0]).parent().clone();
  $newCheckbox.find('.times__suggestion__label').text(date);
  $newCheckbox.addClass('dynamic');
  $newCheckbox.find('input').val(date).prop('checked', true);
  domElements.suggestionsWrap.append($newCheckbox);
  domElements.suggestions = domElements.main.find('.times__suggestion input');
}

function removeUnusedDynamicCheckbox() {
  domElements.suggestionsWrap.find('.dynamic').each((index, element) => {
    if ($(element).find('input:not(:checked)').length > 0) {
      console.log('removeUnusedDynamicCheckbox', $(element));
      $(element).remove();
    }
  });
  domElements.suggestions = domElements.main.find('.times__suggestion input');
}

function parseDates() {
  domElements.dates.each((index, element) => {
    availableDates.push($(element).text());
  });
}

export default step3;
